import React, { useEffect, useState } from "react";
import StepOneMediaAgencyOnboarding from "./component/step-one-media-agency-onboarding";
import StepTwoMediaAgencyOnboarding from "./component/step-two-media-agency-onboarding";
import StepThreeMediaAgencyOnboarding from "./component/step-three-media-agency-onboarding";
import StepFourMediaAgencyOnboarding from "./component/step-four-media-agency-onboarding";
import { useNavigate, useSearchParams } from "react-router-dom";
import useOnboardingStore from "./store/onboardingStore";
import Spinner from "@/components/ui/Spinner";

const MediaAgencyOnboarding: React.FC = () => {
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isTokenInvalid, setIsTokenInvalid] = useState<boolean>(false);

  const navigate = useNavigate();
  const validateToken = useOnboardingStore((state) => state.validateToken);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    setIsLoading(true);
    validateToken(searchParams.get("token")).then((tokenData) => {
      if (tokenData) setIsLoading(false);
      if (!tokenData) {
        setIsLoading(false);
        setIsTokenInvalid(true);
      }
    });
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center w-screen h-screen">
        <Spinner size={30} />
      </div>
    );
  }

  if (isTokenInvalid) {
    return (
      <div className="flex flex-col justify-center items-center w-screen h-screen">
        <div className="font-bold text-2xl mb-4">Link Expired</div>
        <div>
          Oops!! Your onboarding link has been expired. Please try again later.
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="bg-[#EA33C0] h-12"></div>
      {step === 1 && <StepOneMediaAgencyOnboarding onNext={() => setStep(2)} />}

      {step === 2 && <StepTwoMediaAgencyOnboarding onNext={() => setStep(3)} />}

      {step === 3 && (
        <StepThreeMediaAgencyOnboarding
          onNext={() => {
            navigate("/dashboard?onBoardingSuccess=true");
          }}
        />
      )}

      {/* {step === 4 && (
        <StepFourMediaAgencyOnboarding
          onNext={() => {
            navigate("/dashboard");
          }}
        />
      )} */}
    </div>
  );
};

export default MediaAgencyOnboarding;
